import { AxiosError } from 'axios';
import { axiosInstance } from '../api/axios.instance';
import { API_CONFIG } from '../api/config';
import { 
  ObtenerUsuarioResponseSchema,
  transformUsuarioApiToUi,
  type ObtenerUsuarioUi
} from '../schemas/usuarios/obtener-usuario';
import { 
  EditarUsuarioApiSchema,
  type EditarUsuarioUi
} from '../schemas/usuarios/editar-usuario';

export class UsuariosService {
  static async obtenerUsuario(): Promise<ObtenerUsuarioUi> {
    try {
      const response = await axiosInstance.get(
        API_CONFIG.ENDPOINTS.USUARIOS.OBTENER_USUARIO
      );
      
      const validatedData = ObtenerUsuarioResponseSchema.parse(response.data);
      
      return transformUsuarioApiToUi(validatedData);
    } catch (error) {
      if (error instanceof AxiosError) {
        if (error.response?.status === 401) {
          throw new Error('Sesión expirada o no autorizada');
        }
        throw new Error(error.response?.data?.detail || error.message);
      }
      console.error('❗ Error inesperado al obtener información del usuario:', error);
      throw new Error('Error desconocido al obtener información del usuario');
    }
  }

  static async editarUsuario(datos: EditarUsuarioUi): Promise<void> {
    try {
      const datosValidados = EditarUsuarioApiSchema.parse({
        nombre: datos.nombre,
        apellido: datos.apellido
      });

      await axiosInstance.put(
        API_CONFIG.ENDPOINTS.USUARIOS.EDITAR_USUARIO,
        datosValidados
      );
    } catch (error) {
      if (error instanceof AxiosError) {
        if (error.response?.status === 401) {
          throw new Error('Sesión expirada o no autorizada');
        }
        throw new Error(error.response?.data?.detail || error.message);
      }
      console.error('❗ Error inesperado al editar información del usuario:', error);
      throw new Error('Error desconocido al editar información del usuario');
    }
  }

  static async cambiarContrasena(): Promise<void> {
    try {
      await axiosInstance.post(
        API_CONFIG.ENDPOINTS.USUARIOS.CAMBIAR_CONTRASENA
      );
    } catch (error) {
      if (error instanceof AxiosError) {
        if (error.response?.status === 401) {
          throw new Error('Sesión expirada o no autorizada');
        }
        throw new Error(error.response?.data?.detail || error.message);
      }
      console.error('❗ Error inesperado al solicitar cambio de contraseña:', error);
      throw new Error('Error desconocido al solicitar cambio de contraseña');
    }
  }
} 